var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: { title: _vm.$t("influencer_panel.commission_per_day") },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("div", { staticClass: "commission-chart__legend" }, [
                _c(
                  "span",
                  { staticClass: "commission-chart__legend-item" },
                  [
                    _c("span", { staticClass: "commission-chart__dot" }),
                    _vm._v(" " + _vm._s(_vm.currentLabel) + " "),
                    _c("hb-money", {
                      attrs: { cents: _vm.currentTotalCents, size: "sm" },
                    }),
                  ],
                  1
                ),
                _vm.hasPrevious
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "commission-chart__legend-item commission-chart__legend-item--muted",
                      },
                      [
                        _c("span", { staticClass: "commission-chart__dash" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("influencer_panel.previous_period")) +
                            " "
                        ),
                        _c("hb-money", {
                          attrs: { cents: _vm.previousTotalCents, size: "sm" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("vue-apex-charts", {
        attrs: {
          type: "area",
          height: "240",
          options: _vm.chartOptions,
          series: _vm.series,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }